export const NON_DEMO_SCENARIO_LIMIT = 5;
export const NON_DEMO_TARGET_VARIABLE_LIMIT = 2;

export function canAddScenario(isDemoClient, scenarioCount) {
  return isDemoClient || scenarioCount < NON_DEMO_SCENARIO_LIMIT;
}

export function canSelectTargetVariable(
  isDemoClient,
  selectedTargetVars,
  varName
) {
  const selectedVars = selectedTargetVars || [];

  return (
    isDemoClient ||
    selectedVars.includes(varName) ||
    selectedVars.length < NON_DEMO_TARGET_VARIABLE_LIMIT
  );
}
